import { WILDCARD } from './consts';

export const isAllCollapsed = (collapsedGroupIds: string[]): boolean =>
  collapsedGroupIds.includes(WILDCARD);
